/**
 * Tabla de datos del juego.
 *
 * Solo pinta las filas que tienen dato: hoy la mayoría del catálogo está a
 * medio llenar, y una tabla llena de guiones se lee como un error de la web.
 * Si no hay ni un dato, no renderiza nada.
 */

// El orden es el que se muestra en pantalla, del dato más útil al menos.
const CAMPOS = [
  { clave: 'jugadores', etiqueta: 'Jugadores' },
  { clave: 'tiempo', etiqueta: 'Duración' },
  { clave: 'edad_minima', etiqueta: 'Edad recomendada' },
  // La nota completa («AMIGO (edición original alemana); edición en español de
  // Chokolhá Games»), no la marca corta: aquí el comprador sí quiere el detalle
  // de qué edición está comprando. `marca` es el nombre corto que va en la
  // tarjeta y por el que agrupa la analítica. Cae a `marca` para los productos
  // sin ficha curada, donde las dos son el mismo dato.
  { clave: 'editorial', etiqueta: 'Editorial', alterno: 'marca' },
  { clave: 'autor', etiqueta: 'Diseño' },
  { clave: 'anio_publicacion', etiqueta: 'Año' },
  { clave: 'tipo', etiqueta: 'Tipo' },
  { clave: 'categorias', etiqueta: 'Categorías' },
  { clave: 'mecanicas', etiqueta: 'Mecánicas' },
  { clave: 'idioma', etiqueta: 'Idioma' },
  { clave: 'contenido_caja', etiqueta: 'Contenido de la caja' },
];

const tieneValor = valor =>
  valor !== null && valor !== undefined && String(valor).trim() !== '';

export default function FichaTecnica({ producto, className = '' }) {
  if (!producto) return null;

  const valorDe = campo =>
    tieneValor(producto[campo.clave])
      ? producto[campo.clave]
      : campo.alterno
        ? producto[campo.alterno]
        : undefined;

  const filas = CAMPOS.filter(campo => tieneValor(valorDe(campo)));
  if (filas.length === 0) return null;

  return (
    <section className={className} aria-labelledby="ficha-tecnica-titulo">
      <h2 id="ficha-tecnica-titulo" className="font-cinzel text-xl text-df-text mb-4">
        Ficha <span className="text-df-cyan">técnica</span>
      </h2>

      <dl className="divide-y divide-df-border rounded-xl border border-df-border overflow-hidden">
        {filas.map(campo => (
          <div
            key={campo.clave}
            className="grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-4 px-4 py-3 odd:bg-df-surface even:bg-df-surface2"
          >
            <dt className="text-sm font-medium text-df-muted">{campo.etiqueta}</dt>
            <dd className="text-sm text-df-text sm:col-span-2 break-words">
              {String(valorDe(campo)).trim()}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
